import { ReactNode } from 'react';

const SectionTitle = ({ children }: { children: ReactNode }) => (
	<h3 style={{ fontSize: '24px', fontWeight: 700, lineHeight: '32px', padding: 0, margin: 0 }}>{children}</h3>
);

export default SectionTitle;
